<template>
  <form class="filters">
    <v-layout row wrap>
      <v-flex>
        <v-autocomplete
          v-model="filtros.usuario"
          :items="view.elem.select.usuario.filteredList"
          :label="$t('view.commons.usuario')"
          :error-messages="getFirstErrorDescription($v.filtros.usuario)"
          item-text="name"
          item-value="code"
          :disabled="view.action.submit.busy"
          multiple
          hide-selected
          clearable
          dense
          deletable-chips
          small-chips
          @input="search = ''" />
      </v-flex>

      <v-flex>
        <v-autocomplete
          v-model="view.elem.select.modulo.value"
          :items="view.elem.select.modulo.filteredList"
          :label="$t('view.bitacoras.reporteAuditoria.form.modulo.label')"
          :error-messages="getFirstErrorDescription($v.view.elem.select.modulo.value)"
          item-text="name"
          item-value="code"
          :disabled="view.action.submit.busy"
          dense
          clearable />
      </v-flex>

      <v-flex>
        <datePicker
          ref="datePickerDateIni"
          :key="refreshkey"
          :name="'dateIni'"
          :type="'date'"
          :label="$t('view.commons.dateIni')"
          :errormessages="getFirstErrorDescription($v.view.elem.dateIni)"
          :value.sync="view.elem.dateIni"
          :dense="true"
          :disabled="view.action.submit.busy"
          @changeDate="changeDate" />
      </v-flex>

      <v-flex>
        <datePicker
          ref="datePickerDateEnd"
          :key="refreshkey"
          :name="'dateEnd'"
          :type="'date'"
          :label="$t('view.commons.dateEnd')"
          :errormessages="getFirstErrorDescription($v.view.elem.dateEnd)"
          :value.sync="view.elem.dateEnd"
          :disabled="view.action.submit.busy"
          :min="view.elem.dateIni"
          :dense="true"
          :enable-today="new Date(view.elem.dateIni) <= new Date()"
          @changeDate="changeDate" />
      </v-flex>

      <v-flex>
        <v-btn fab x-small color="primary" elevation="0" class="btn_tippy ml-4" :title="$t('view.commons.search')" :loading="view.action.submit.busy" @click="filter">
          <v-icon x-small>fas fa-search</v-icon>
        </v-btn>
        <v-btn fab x-small color="primary" elevation="0" class="btn_tippy ml-4" :title="$t('view.commons.report')" :loading="view.action.submit.busy" @click="report">
          <v-icon x-small>far fa-file-excel</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
  </form>
</template>
<script>
import CombosAPI from "@/services/catalogos"; /** *******************************/
import DatePicker from "@/components/forms/DatePicker"; /** *******************************/
import tippy from "tippy.js";
import { required } from "vuelidate/lib/validators";
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";
import { setToday } from "@/helpers/date-methods";
import { allValidatorMethods } from "@/helpers/vuelidate";

export default {
  name: "FiltersModule"
  , components: { DatePicker }
  , props: {
    select: {
      default: null
      , type: Object
    }
  }
  , data() {
    return {
      refreshkey: 0
      , view: {
        elem: {
          menu: { visible: false }
          , select: {
            usuario: {
              completeList: []
              , filteredList: []
            }
            , modulo: {
              completeList: []
              , filteredList: []
              , value: ""
            }
          }
          , dateIni: setToday()
          , dateEnd: setToday()
        }
        , action: { submit: { busy: false } }
      }
      , filtros: {
        usuario: []
        , modulo: []
        , fecha: []
      }
    };
  }
  , updated() {
    tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
  }
  , created() {
    this.$nextTick(() => this.loadSelectsData());
  }
  , methods: {
    ...allValidatorMethods
    , getfilters() {
      delete this.filtros.report;
      this.filtros.modulo = [];
      this.filtros.modulo.push(this.view.elem.select.modulo.value);
      this.filtros.fecha = [];
      this.filtros.fecha.push(`(${this.view.elem.dateIni}|${this.view.elem.dateEnd})`);
      return this.filtros;
    }
    , filter() {
      if (!this.isAllValid(this.$v)) {
        EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", this.$t("errors.validof"));
        return false;
      }
      this.$emit("filter", this.getfilters());
    }
    , report() {
      if (!this.isAllValid(this.$v)) {
        EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", this.$t("errors.validof"));
        return false;
      }
      this.$emit("report", this.getfilters());
    }
    , changeDate(field, value) {
      this.view.elem[field] = value;
      this.changeDateIni();
    }
    , changeDateIni() {
      if (new Date(this.view.elem.dateIni) > new Date(this.view.elem.dateEnd)) {
        this.view.elem.dateEnd = this.view.elem.dateIni;
        this.refreshkey += 1;
      }
    }
    , async loadSelectsData() {
      await this.loadSelectUsuariosActivos();
      await this.loadSelectModulos();
      this.refreshkey += 1;
    }
    , async loadSelectUsuariosActivos() {
      const { data: { results: { combo: responseUsuarioList } } } = await CombosAPI.get({ option: "usuariosActive" });
      this.view.elem.select.usuario.filteredList = responseUsuarioList ? responseUsuarioList.filter((value) => value.status) : [];
      this.view.elem.select.usuario.completeList = responseUsuarioList || [];
    }
    , async loadSelectModulos() {
      const { data: { results: { combo: responseModulosList } } } = await CombosAPI.get({ option: "modulos" });
      responseModulosList.sort((a, b) => (a.name > b.name ? 1 : -1));
      this.view.elem.select.modulo.filteredList = responseModulosList || [];
      this.view.elem.select.modulo.completeList = responseModulosList || [];
    }
    , async loading(status = false) {
      this.view.action.submit.busy = status;
    }
  }
  , validations: {
    filtros: { usuario: { required } }
    , view: {
      elem: {
        select: { modulo: { value: { required } } }
        , dateEnd: { required }
        , dateIni: { required }
      }
    }
  }
};
</script>

<style scoped>
.filter_button {
  margin-top: 15px;
  width: 35px !important;
  height: 35px !important;
  font-size: 10px !important;
}
.filter_button .v-icon {
  font-size: 15px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/bitacoras/reporteAuditoria/Filters.vue